"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeTypeSchema = exports.NodeConfigSchema = exports.IntermediateNodeSchema = exports.IntermediateNodeConfigSchema = exports.artifactType = void 0;
const zod_1 = require("zod");
const finley_types_1 = require("@finley-technologies/finley-types");
const tape_builder_base_1 = require("../../types/tape-builder-base");
exports.artifactType = 'borrowingBaseReport';
// Intermediate config schema
exports.IntermediateNodeConfigSchema = zod_1.z
    .object({
    operationDescription: zod_1.z
        .string()
        .optional()
        .describe('Deprecated: not generated by tape-builder but retained for backwards compatibility'),
    tapeDescription: zod_1.z.string().describe('Description shown in the tape node'),
    createServicerReport: zod_1.z
        .boolean()
        .optional()
        .describe('Whether to generate a servicer report'),
    fundingSubmissionArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Slug for funding submission components artifact').optional(),
    extendedResponseTapeUploads: zod_1.z
        .array(zod_1.z
        .object({
        loanProductSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Loan product slug reference for the extended response tape upload'),
        uploadPath: zod_1.z.string(),
    })
        .describe('Upload settings for each extended response tape (per loan product)'))
        .optional(),
})
    .describe('Intermediate node configuration');
// Intermediate node schema
exports.IntermediateNodeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
    creditFacilitySlug: true,
    externalFilename: true,
    loanProductSlug: true,
}).extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    loanProductSlug: zod_1.z.string().nullable(),
    creditFacilitySlug: zod_1.z.string().nullable(),
    configuration: exports.IntermediateNodeConfigSchema,
});
// DB config schema (extends intermediate)
exports.NodeConfigSchema = exports.IntermediateNodeConfigSchema.extend({
    receivableResponseTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Slug for receivable response tape artifact'),
    cashBalancesFeedContextArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Optional slug for cash balances feed context artifact')
        .nullable()
        .optional(),
    cashResponseTapeArtifactSlug: (0, tape_builder_base_1.zArtifactSlugRef)('Optional slug for cash response tape artifact')
        .nullable()
        .optional(),
}).describe('DB node configuration');
// Full node schema
exports.NodeTypeSchema = finley_types_1.DbTable.ArtifactWithSlugsSchema.omit({
    configuration: true,
    type: true,
}).extend({
    externalFilename: zod_1.z.null(),
    type: zod_1.z.literal(exports.artifactType),
    creditFacilitySlug: zod_1.z.string(),
    loanProductSlug: zod_1.z.null(),
    configuration: exports.NodeConfigSchema,
});
//# sourceMappingURL=node.js.map